import React, { useEffect } from 'react'
import Head from 'next/head';
import { useRouter } from 'next/router';
import JobHeader from '../../Components/Header/JobHeader';
import Footer from '../../Components/Footer/Footer';
import { getOS } from '../../utils/os.util';



const AppLink = (props) => {

  const router = useRouter();
  const { query: { noHeader, noFooter, pathname } } = router;




  useEffect(() => {

    if (router.isReady) {
      if (getOS() == 'android') {
        setTimeout(() => {
          location.replace(process.env.PLAY_STORE_LINK)
        }, 200)
        location.replace('skatch://' + pathname)
      } else {
        // router.replace('/')
        location.replace(process.env.PLAY_STORE_LINK)
      }
    }
  }, [router])


  return (
    <>
      <Head>

        <title>Job openings on Skatch App</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <meta name="description" content="Check out the latest job opportunities! Skatch makes job search simple and effective. Find Jobs &amp; apply for Free." />

        <meta property="og:title" content="Job openings on Skatch App" />
        <meta property="og:description" content="Check out the latest job opportunities! Skatch makes job search simple and effective. Find Jobs &amp; apply for Free." />
        <meta name="twitter:title" content="Job openings on Skatch App" />
        <meta name="twitter:description" content="Check out the latest job opportunities! Skatch makes job search simple and effective. Find Jobs &amp; apply for Free." />

      </Head>
      <div className="main-page-wrapper font-gordita about-wrapper">
        {noHeader ? null : <JobHeader dynamicSlug={router?.route?.split("/").pop() ? '/' + router?.route?.split("/").pop() : '/'} />}
        <div className="container-fluid p-5">

        </div>
        {noFooter ? null : <Footer />}

      </div>
    </>
  );
}

export default AppLink